export enum PriceFormat {
  NUMBER_ONLY = "number only",
  DISPLAY_FREE_AS_kostenlos = "display free as KOSTENLOS",

  HIDE = "hide", // used in config: has side effect similar to "event.display_price_card": false
  HIDE_ON_FREE = "hide on free",
}
